import { apyToAprPercent } from '../../../utils/parsing'
import { YieldFetcher } from '../../types'

const SSUPERUSD_URL =
  'https://www.superreturn.ai/api/trpc/cmc.getUSDCPrice,rewardBackend.getYield,rewardBackend.getTvlChange?batch=1&input=%7B%220%22%3A%7B%22json%22%3Anull%2C%22meta%22%3A%7B%22values%22%3A%5B%22undefined%22%5D%7D%7D%2C%221%22%3A%7B%22json%22%3Anull%2C%22meta%22%3A%7B%22values%22%3A%5B%22undefined%22%5D%7D%7D%2C%222%22%3A%7B%22json%22%3Anull%2C%22meta%22%3A%7B%22values%22%3A%5B%22undefined%22%5D%7D%7D%7D'
const ssuperusd = 'SuperReturn sSuperUSD::SSUPERUSD'

export const ssuperusdFetcher: YieldFetcher = {
  label: 'SSUPERUSD',
  fetch: async () => {
    try {
      const res = await fetch(SSUPERUSD_URL, {
        method: 'GET',
        headers: { Accept: 'application/json', 'User-Agent': '1delta/yields' },
      }).then((r) => r.json())
      return { [ssuperusd]: apyToAprPercent(res?.[1]?.result.data.json ?? 0) }
    } catch (e) {
      return { [ssuperusd]: 0 }
    }
  },
}
